// 引入配置路由的相关信息
import Vue from "vue";
import VueRouter from "vue-router";
import turnimg from'@/components/pc/TurnjsComponent.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import('@/components/pc/main.vue'),
  },
  {
    path: '/map',
    component: () => import('@/components/pc/map.vue'),
  },
  {
    path: '/main',
    component: () => import('@/components/pc/main.vue'),
  },
  {
    path: '/catalog',
    component: () => import('@/components/pc/catalog.vue'),
  },
  {
    path: '/search',
    name:'search',
    // props:true,
    component: () => import('@/components/pc/search.vue'),
  },
  {
    path: '/turn',
    component: turnimg,
  },
];

// 创建路由对象
const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

/**
 * 判断是否为移动设备，是，则跳转到移动端的路径
 */
router.beforeEach((to, from, next) => {
  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    window.location.href = '/m_index.html#/'
    return
  }
  next()
})
// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

// 将 router 对象导出
export default router;
